import {palette, PaletteColor} from "../styles";
import {SVGProps} from "react";

export type IconSize =
    | "x-small"
    | "small"
    | "default"
    | "medium"
    | "large"
    | "x-large"
    | "xx-large"
    | "img-large";

export type SystemIconProps = {
    size: IconSize;
    color?: PaletteColor;
    className?: string;
};

export type AccSystemIconProps = SystemIconProps & SVGProps<SVGElement>;

export type UniCreditIconProps = {
    size: IconSize;
} & (
    | {
    monochromatic: true;
    color: PaletteColor;
}
    | {
    monochromatic?: false;
    color?: never;
}
    );

export function getSystemIconFillColor(color?: string): string {
    return color || "currentColor";
}

export function getUniCreditIconFillColors(props: UniCreditIconProps): {
    primaryColor: string;
    secondaryColor: string;
} {
    return {
        primaryColor: props.monochromatic ? props.color : palette.red800,
        secondaryColor: props.monochromatic ? props.color : palette.neutral800,
    };
}

export const iconSizes = {
    "xx-small": "14px",
    "x-small": "16px",
    "small": "20px",
    default: "24px",
    medium: "32px",
    large: "40px",
    "x-large": "56px",
    "xx-large": "72px",
    "img-large": "100px"
};